







































import { Component, Prop, Ref } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import InputSuketPulangCard from "@/components/pemeriksaan/resumeSuketV2/InputSuketPulangCard.vue";
import StoreSuketPulang from "@/store/modules/SuketPulang";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import PDFViewer from "@/components/PDFViewer.vue";

@Component({
  components: {
    CardModalTtd,
    InputSuketPulangCard,
    BaseSuketCard,
    PDFViewer
  }
})
export default class SuketPulangCard extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;
  @Ref() pdfEl: any;

  allowedUnit = ["01"];
  suketSvc = new CommonSuket(EnSuketCategory.Pulang);
  suketStore = StoreSuketPulang;

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.Pulang, this.dataSuket.id)
      : null;
  }

  print() {
    this.pdfEl.print();
  }
}
